import styled from "styled-components";
import { SIDEBAR_W } from "../../config/layout";

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 40px;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 580px;
`;

export const PageTitle = styled.h1`
  color: #1b3a6b;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 20px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
`;

export const UserHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 28px;
`;

export const UserAvatar = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  background: #e8f0f7;
  flex-shrink: 0;
`;

export const UserId = styled.p`
  font-size: 1rem;
  color: #222;
  margin: 0;

  span {
    font-weight: 700;
    color: #1b3a6b;
  }
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 22px 32px;
`;

export const FieldItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled.p`
  margin: 0;
  font-size: 0.78rem;
  color: #888;
`;

export const FieldValue = styled.p`
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: #222;
  white-space: pre-wrap;
`;

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #eef3f7;
`;

export const EditButton = styled.button`
  padding: 10px 22px;
  border-radius: 8px;
  border: none;
  background: #3d7a8a;
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #2e5f6e; }
`;

export const DeleteButton = styled.button`
  padding: 10px 22px;
  border-radius: 8px;
  border: 1.5px solid #e53e3e;
  background: #fff;
  color: #e53e3e;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #fff5f5; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
